export default {
  CAPTACHA_ENABLED: 'captchaEnabled',
  CLONEABLE: 'cloneable',
  CREATED_AT: 'createdAt',
  DELETABLE: 'deletable',
  EMBED_VERSION: 'embedVersion',
  FIELD_PREPOPULATION: 'ignoreCurrentValues',
  FORM_FIELD_GROUPS: 'formFieldGroups',
  GUID: 'guid',
  META_DATA: 'metaData',
  NAME: 'name',
  NOTIFY_RECIPIENTS: 'notifyRecipients',
  REDIRECT_PAGE: 'redirect',
  SUBMIT_TEXT: 'submitText',
  THANK_YOU_MESSAGE: 'inlineMessage',
  THEME_NAME: 'themeName',
  UPDATED_AT: 'updatedAt',
  FORM_TYPE: 'formType',
  STYLE: 'style',
  ALWAYS_CREATE_NEW_COMPANY: 'alwaysCreateNewCompany',
  CREATE_MARKETABLE_CONTACT: 'createMarketableContact',
  PORTALID: 'portalId',
  ACTION: 'action',
  METHOD: 'method',
  CSS_CLASS: 'cssClass',
  LEAD_NUTURING_CAMPAIGN_ID: 'leadNurturingCampaignId',
  PERFORMANCE_HTML: 'performableHtml',
  MIGRATED_FROM: 'migratedFrom',
  TMS_ID: 'tmsId',
  CAMPAIGN_GUID: 'campaignGuid',
  EDITABLE: 'editable',
  DELETED_AT: 'deletedAt',
  PARENT_ID: 'parentId',
  IS_PUBLISHED: 'isPublished',
  PUBLISH_AT: 'publishAt',
  UNPUBLISH_AT: 'unpublishAt',
  PUBLISHED_AT: 'publishedAt',
  CUSTOM_UID: 'customUid',
  EDIT_VERSION: 'editVersion',
  THANK_YOU_MESSAGE_JSON: 'thankYouMessageJson',
  THEME_COLOR: 'themeColor',
  INTERNAL_UPDATED_AT: 'internalUpdatedAt',
  BUSINESS_UNIT_ID: 'businessUnitId',
  PORTABLE_KEY: 'portableKey',
  SELECTED_EXTERNAL_OPTIONS: 'selectedExternalOptions',
  MAYBE_SET_DEFAULTS: 'maybeSetDefaults'
};